class Model {
  map(json) {
    if (json) {
      Object.keys(json).forEach((key) => {
        const camelCaseKey = key.replace(/[-_\s]+(.)?/g, (match, ch) =>
          (ch ? ch.toUpperCase() : ''));
        if (typeof (json[key]) !== 'object' || json[key] == null) {
          this[camelCaseKey] = json[key];
        }
      });
      if (json.errors != null) {
        this.errors = json.errors;
      }
    }
    // eslint-disable-next-line no-underscore-dangle
    // this._modelName = this.constructor.name;
  }

  mapArray(property, array, Klazz) {
    const mappedArray = array.map((x) => {
      const mappedObject = new Klazz();
      mappedObject.map(x);
      return mappedObject;
    });
    this[property] = mappedArray;
  }

  hasError() {
    return this.errors !== undefined && this.errors.length > 0;
  }

  errorMessage() {
    return this.errors.map(e => e.message).join(', ');
  }
}
export default Model;
